export default __webpack_public_path__ + "static/media/banner1.0b7042f9.webp";